const accordion = <HTMLElement>document.querySelector(".accordion");

if (accordion) {
    const panels = accordion.querySelectorAll<HTMLElement>(".accordion__panel");
    panels.forEach((panel) => {
        panel.addEventListener("click", () => {
            toggleAccordion(panel);
        });
    });

    const toggleAccordion = (panelToActivate: Element) => {
        const activeButton = panelToActivate.querySelector("button");
        const activePanelIsOpened = activeButton.getAttribute("aria-expanded");

        let setClickPanelActive: boolean = true;
        // if panel already open -> close
        if (activePanelIsOpened === "true") {
            setClickPanelActive = false;
        }

        panelToActivate.querySelector("button").setAttribute("aria-expanded", setClickPanelActive.toString());
        panelToActivate
            .querySelector(".accordion__content")
            .setAttribute("aria-hidden", (!setClickPanelActive).toString());
    };
}
